import client from '@/api/client';
import { BASE_URL, COMM_URL } from '@/constants';
import _ from 'lodash';

export default {
	selectTaskCommCdMstList: ({ mstCd, useYn, currentPage, pageUnit, mstCdName }) => {
		const params = { mstCdName, pageUnit, currentPage };
		const queryString =
			'?' +
			Object.entries(params)
				.map(([key, val]) => (!_.isNil(val) ? `${key}=${val}` : ''))
				.filter(r => r)
				.join('&');

		//console.log(`${BASE_URL}/taskCommCd/v1/mstCd/${mstCd}/useYn/${useYn}`);

		return client.get(`${BASE_URL}/taskCommCd/v1/mstCd/${mstCd}/useYn/${useYn}` + queryString).then(res => res.data);
	},
	selectTaskCommCdList: ({ mstCd, currentPage, pageUnit }) =>
		client
			.get(`${BASE_URL}/taskCommCd/v1/mstCd/${mstCd}/dtlCd?currentPage=${currentPage}&pageUnit=${pageUnit}`)
			.then(res => res.data),
	deleteTaskCommCdMst: body => client.post(`${BASE_URL}/taskCommCd/v1/mstCd/delete`, body).then(res => res.data),
	saveTaskCommCdMst: body => client.post(`${BASE_URL}/taskCommCd/v1/mstCd/save`, body).then(res => res.data),
	deleteTaskCommCd: body => client.post(`${BASE_URL}/taskCommCd/v1/dtlCd/delete`, body).then(res => res.data),
	saveTaskCommCd: body => client.post(`${BASE_URL}/taskCommCd/v1/dtlCd/save`, body).then(res => res.data)
};
